import { Controller } from "@hotwired/stimulus"
import Cropper from "cropperjs"

export default class extends Controller {
  stream = null
  cropper = null

  cropControlsBound = false

  disconnect() {
    this.stopWebcam()
    if (this.cropper) this.cropper.destroy()
  }

  openModal(e) {
    e.preventDefault()
    const modal = this.element.querySelector("#webcamModal")
    modal.classList.add("show")
    modal.style.display = "block"
    document.body.classList.add("modal-open")
    
    const backdrop = document.createElement("div")
    backdrop.className = "modal-backdrop fade show"
    backdrop.id = "webcamBackdrop"
    backdrop.onclick = () => this.closeModal()
    document.body.appendChild(backdrop)
    
    this.showStep("webcam")
    this.startWebcam()
  }

  closeModal(e) {
    if (e) e.preventDefault()
    const modal = this.element.querySelector("#webcamModal")
    modal.classList.remove("show")
    modal.style.display = "none"
    document.body.classList.remove("modal-open")
    
    const backdrop = document.querySelector("#webcamBackdrop")
    if (backdrop) backdrop.remove()
    
    this.stopWebcam()
    if (this.cropper) {
      this.cropper.destroy()
      this.cropper = null
    }
  }

  startWebcam() {
    navigator.mediaDevices.getUserMedia({ video: true })
      .then(s => {
        this.stream = s
        const video = this.element.querySelector("#webcam_video")
        video.srcObject = s
        video.play()
      })
      .catch(() => alert("Accès webcam refusé"))
  }

  stopWebcam() {
    if (this.stream) {
      this.stream.getTracks().forEach(t => t.stop())
      this.stream = null
    }
  }

  capture(e) {
    e.preventDefault()
    const video = this.element.querySelector("#webcam_video")
    const canvas = this.element.querySelector("#canvas")
    const ctx = canvas.getContext("2d")

    canvas.width = 640
    canvas.height = 480
    ctx.drawImage(video, 0, 0, 640, 480)

    const dataUrl = canvas.toDataURL("image/jpeg", 0.9)
    this.stopWebcam()

    const preview = this.element.querySelector("#crop_preview")
    preview.src = dataUrl

    this.showStep("crop")

    setTimeout(() => {
      if (this.cropper) this.cropper.destroy()
      this.cropper = new Cropper(preview, {
        aspectRatio: 1,
        preview: ".preview",
        autoCropArea: 1,
        dragMode: "move",
        viewMode: 1
      })

      this.bindCropControls()
    }, 300)
  }

  bindCropControls() {
    if (this.cropControlsBound) return

    const moveModeBtn = this.element.querySelector("#btn-move-mode")
    const cropModeBtn = this.element.querySelector("#btn-crop-mode")
    const zoomMinusBtn = this.element.querySelector("#btn-zoom-minus")
    const zoomPlusBtn = this.element.querySelector("#btn-zoom-plus")

    if (!moveModeBtn || !cropModeBtn || !zoomMinusBtn || !zoomPlusBtn) return

    moveModeBtn.addEventListener("click", (e) => {
      e.preventDefault()
      if (this.cropper) this.cropper.setDragMode("move")
    })

    cropModeBtn.addEventListener("click", (e) => {
      e.preventDefault()
      if (this.cropper) this.cropper.setDragMode("crop")
    })

    zoomPlusBtn.addEventListener("click", (e) => {
      e.preventDefault()
      if (this.cropper) this.cropper.zoom(0.1)
    })

    zoomMinusBtn.addEventListener("click", (e) => {
      e.preventDefault()
      if (this.cropper) this.cropper.zoom(-0.1)
    })

    this.cropControlsBound = true
  }

  retake(e) {
    e.preventDefault()
    if (this.cropper) {
      this.cropper.destroy()
      this.cropper = null
    }

    this.cropControlsBound = false
    this.showStep("webcam")
    this.startWebcam()
  }

  save(e) {
    e.preventDefault()
    if (!this.cropper) return

    const croppedCanvas = this.cropper.getCroppedCanvas({ width: 480, height: 480 })
    if (!croppedCanvas) return

    const dataUrl = croppedCanvas.toDataURL("image/jpeg", 0.92)
    const base64 = dataUrl.split(",")[1]
    const blob = this.base64ToBlob(base64, "image/jpeg")

    const formData = new FormData()
    formData.append("user[identity_photo]", blob, "identity_photo.jpg")
    // On force le statut à pending, pour éviter que l'écran affiche "missing"
    formData.append("user[identity_photo_status]", "identity_photo_pending")

    const token = document.querySelector("meta[name=csrf-token]")?.content

    fetch("/fr/dashboard/profile", {
      method: "PATCH",
      headers: { "X-CSRF-Token": token },
      body: formData
    }).then(r => {
      if (r.ok) {
        this.closeModal()
        window.location.href = "/fr/dashboard/profile"
      } else {
        alert("Erreur lors de l'enregistrement")
      }
    })
  }

  showStep(step) {
    this.element.querySelector("#step_webcam").classList.toggle("d-none", step !== "webcam")
    this.element.querySelector("#step_crop").classList.toggle("d-none", step !== "crop")
    this.element.querySelector("#footer_webcam").classList.toggle("d-none", step !== "webcam")
    this.element.querySelector("#footer_crop").classList.toggle("d-none", step !== "crop")
  }

  base64ToBlob(base64, mime) {
    const chars = atob(base64)
    const arr = new Uint8Array(chars.length)
    for (let i = 0; i < chars.length; i++) arr[i] = chars.charCodeAt(i)
    return new Blob([arr], { type: mime })
  }
}
